import { useTheme } from 'foundations-theming/utils';
import styled from 'styled-components';
import { convertUseToRingColor, formatScoreValue } from '../../utils/scoreRing';
import { jsx as _jsx } from "react/jsx-runtime";
const Ring = styled.div.withConfig({
  displayName: "ScoreRing__Ring",
  componentId: "sc-5iy4qw-0"
})(["border-radius:50%;border:3px solid ", ";height:40px;position:relative;width:40px;"], props => props.theme.color);
const Score = styled.p.withConfig({
  displayName: "ScoreRing__Score",
  componentId: "sc-5iy4qw-1"
})(["color:", ";padding-bottom:", ";font-size:18px;font-weight:600;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);word-break:normal;"], props => props.theme.color, props => props.theme.paddingAdjustment ? '1px' : '0');
const ScoreRing = props => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(Ring, {
    "data-test-id": "score-ring",
    theme: {
      color: convertUseToRingColor(props.use)
    },
    children: props.use === 'none' ? /*#__PURE__*/_jsx(Score, {
      theme: {
        color: trellisTheme.color['do-not-use-battleship'],
        paddingAdjustment: true
      },
      children: "--"
    }) : /*#__PURE__*/_jsx(Score, {
      theme: {
        color: trellisTheme.color['do-not-use-obsidian']
      },
      children: formatScoreValue(props.value)
    })
  });
};
export default ScoreRing;